import { AppLayout, Flashbar, FlashbarProps } from '@amzn/awsui-components-core';
import React, { useMemo, useState } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { ApplicationDropdowns } from 'src/components/context/AppContextModels';
import { useAppContext } from 'src/components/context/AppContextProvider';
import { FinOpsTable } from 'src/components/fintech-ops/fintech-ops-table/FinOpsTable';

import { ErrorFallback } from 'src/components/generic-components/ErrorFallback';
import { appLayoutAriaLabels } from 'src/i18n-strings';
import { buildBreadcrumbChain } from 'src/utilities/RouteConfig';
import { AdminSideNavigationV2 } from '../AdminSideNavigationV2';
import { getMetadataFilterProperties, getMetadataTableColumns, transformDropdownsToTableData } from './MetadataTableUtils';

export const initializeApplicationDropdowns = () => {
  return {
    listApplicationOwners: [],
    listGLAccounts: [],
    listToolUI: [],
    listAccessLevels: [],
    listTimeGranularity: [],
    listKeyDimension: [],
    listLastEnhanced: [],
    listProcess: [],
    listScenario: []
  } as ApplicationDropdowns;
};

export const ViewMetadata: React.FC = () => {
  const [flashbarItems, setFlashbarItems] = useState<FlashbarProps.MessageDefinition[]>([]);
  const { listApplicationDropdowns } = useAppContext();
  const listAppDropdowns: ApplicationDropdowns = listApplicationDropdowns ? listApplicationDropdowns : initializeApplicationDropdowns();

  // Transform dropdown data for table display
  const tableData = useMemo(() => transformDropdownsToTableData(listAppDropdowns), [listAppDropdowns]);

  // Get table configuration
  const columnDefinitions = useMemo(() => getMetadataTableColumns(), []);
  const filterProperties = useMemo(() => getMetadataFilterProperties(), []);

  return (
    <>
      <AppLayout
        headerSelector="#h"
        ariaLabels={appLayoutAriaLabels}
        toolsHide
        navigation={<AdminSideNavigationV2 />}
        stickyNotifications
        notifications={<Flashbar items={flashbarItems} />}
        contentType="default"
        content={
          <ErrorBoundary
            FallbackComponent={ErrorFallback}
            onReset={() => {
              window.location.reload();
            }}
          >
            <div className="app-layout-body">
              <FinOpsTable
                data={tableData}
                columnDefinitions={columnDefinitions}
                filterProperties={filterProperties}
                headerName="Application Metadata"
                emptyMessage="No metadata available to display."
                pageSize={200}
                enableDownloadReport={false}
              />
            </div>
          </ErrorBoundary>
        }
      />
    </>
  );
};
